import { render, staticRenderFns } from "./topRanking.vue?vue&type=template&id=7cfe3ebb&"
import script from "./topRanking.vue?vue&type=script&lang=js&"
export * from "./topRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports